import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";
import {ORGANIZATION_SERVER} from "@/api";

const rolePermission = new RestResource({server: ORGANIZATION_SERVER, resource: 'rolePermission'});

rolePermission.batchAdd = (rolePermissions) => {
    let roleId = rolePermissions[0].roleId;
    let permissionIds = rolePermissions.map(e => e.permissionId);
    let url = `${ORGANIZATION_SERVER}/rolePermission/bind/roleid/${roleId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, permissionIds).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

rolePermission.batchDelete = (rolePermissions) => {
    let roleId = rolePermissions[0].role.id;
    let permissionIds = rolePermissions.map(e => e.permission.id);
    let url = `${ORGANIZATION_SERVER}/rolePermission/unbind/roleid/${roleId}`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, permissionIds).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

rolePermission.rolePage = (permissionId, pageSearch) => {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/rolePermission/page/${permissionId}`, pageSearch)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
};

rolePermission.selectBindPermissionIds = (roleId) => {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/rolePermission/permission/${roleId}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
};

rolePermission.bindRoleMenu = (roleId, menuIds) => {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/roleMenu/bind/role/${roleId}`, menuIds)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
};

rolePermission.rolePermissionPage = (pageSearch) => {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/rolePermission/rolePermissionPage`, pageSearch)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
};

export default rolePermission;
